import { render, staticRenderFns } from "./AdminArchivedDevices.vue?vue&type=template&id=21d97dc6&scoped=true&"
import script from "./AdminArchivedDevices.vue?vue&type=script&lang=js&"
export * from "./AdminArchivedDevices.vue?vue&type=script&lang=js&"
import style0 from "./AdminArchivedDevices.vue?vue&type=style&index=0&id=21d97dc6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d97dc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21d97dc6')) {
      api.createRecord('21d97dc6', component.options)
    } else {
      api.reload('21d97dc6', component.options)
    }
    module.hot.accept("./AdminArchivedDevices.vue?vue&type=template&id=21d97dc6&scoped=true&", function () {
      api.rerender('21d97dc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/AdminArchivedDevices.vue"
export default component.exports